import React, { Component } from 'react';
import './About.scss'
import { Banner } from '../../Components'
import Options from './Options'
import {Helmet} from "react-helmet"


class About extends Component {

    componentDidMount() {
        window.scrollTo(0,0)
    }
    
    render() {
        return (
            <div>
				<Helmet>
					<title>About | GPbook</title>
				</Helmet>	
                <Banner title="About" subtitle="About GPbook and The Medical & Surgical Specialist Referral Directory" />
                <div className="page about-page">
                    <div className="container">
                        <Options />
                    </div>
                    <AboutHodby />
                    <Team />
                </div>
            </div>
        );
    }
}

const AboutHodby = () =>
    <div className="container history">
        <h3 className="base">History</h3>
        <h4>The Origins of the Directory</h4>
        <p>The Specialist Referral Directory has been published in Western Australia for over 20 years since 1993. A draft directory of GP services was published through the RACGP WA in 1989. The current Directory was first published in 1993 following a Demonstration Practice Grant from the Commonwealth Department of Health, Housing and Community Services, General Practice Funding Section, General Practice Branch, Ref: 2/06103[D92/0477].</p>
        <h4>What it provided</h4>
        <p>As a Specialist Directory, an in-depth list of system was created. Each category has Specialists listed in alphabetical order with alternate contact details, listing of special interests in practice, areas of exclusion, languages spoken, and private & public hospital accreditations.</p>
        <p>Each category has a sub-index of Practice Locality, Special Interests and Languages spoken. The Directory contains master indexes of Names, Special Interests and Department of Veterans Affairs accreditation.</p>

        <h4>Going Online</h4>        
        <p> GPbook is now an online specialist directory for GPs made locally in Perth. We want to make it easy for GPs to find a specialist to refer their patients to. We offer GPs comprehensive information about specialists so that they can make referrals to the right specialist, saving them time and improving the referral experience for patients.</p>
        <p>Specialists can let GPs know about their special interests, sub-specialisations, billing arrangements, details about the types of patients they do or do not see and leave plans. Listings can include an introduction and a photo so that GPs and patients can get to know their specialists better.</p>
    </div>  

const Team = () =>
    <div className="container team">
        <h3>Founders</h3>
        <p>The founders of GPbook include Stephen Hodby, Cory Lei and Adrian Twarog. The development of which has been going on for the larger part of a year in order to bring the directory from an offline physical book, to an online service that has been improved and updated.</p>
        <div className="founders">
            <div className="row">
                <div className="col-md-4">
                    <div className="image" style={{ backgroundImage: `url(${require('./hodby.jpg')})` }}></div>
                    <h4>Stephen Hodby</h4>
                    <p>With a strong background in medicine, Stephen brings over 40 years of experience. He founded the original book that is now used all over Western Australia as the foundation to refer patients to specialists.</p>
                </div>
                <div className="col-md-4">
                    <div className="image" style={{ backgroundImage: `url(${require('./cory.jpg')})` }}></div>
                    <h4>Cory Lei</h4>
                    <p>Cory is a recent Fellow of the RACGP and has a strong interest in improving the profession.</p>
                </div>
                <div className="col-md-4">
                    <div className="image" style={{ backgroundImage: `url(${require('./adrian.jpg')})` }}></div>
                    <h4>Adrian Twarog</h4>
                    <p>With a background at the Chamber of Commerce and Industry of WA, Adrian has been actively working to make it easier to do business for a number of years. </p>
                </div>
            </div>
        </div>    
    </div>  


export default About;


// WEBPACK FOOTER //
// ./src/Containers/About/About.js